/**
 * Generates a unique form field name for a quiz question.
 * @param questionId - The ID of the quiz question
 * @returns A string in the format "question-{id}"
 */
export function makeQuizQuestionInputKey(questionId: number): string {
  return `question-${questionId}`;
}

